import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { TextField } from "@mui/material";
import { SequenceStateStore } from "../store/SequenceStateStore";
import { SequencePersistenceService } from "../services/SequencePersistenceService";

export const SEQUENCE_TRACK_ROW_HEIGHT = "5.5rem";
export const SEQUENCE_TRACK_LABELS_WIDTH_PX = 170;

export const SequenceTrackNameField: React.FC<{ layerId: string }> = observer(({ layerId }) => {
    const layerName = SequenceStateStore.getLayerName(layerId) || "";
    const [name, setName] = useState(layerName);

    useEffect(() => {
        setName(layerName);
    }, [layerName, layerId]);

    const handleBlur = async () => {
        const trimmed = name.trim();
        const currentLayerName = SequenceStateStore.getLayerName(layerId) || "";
        if (!trimmed) {
            setName(currentLayerName);
            return;
        }
        if (trimmed === currentLayerName) return;

        SequenceStateStore.setLayerName(layerId, trimmed);
        await SequencePersistenceService.updateLayerName(layerId, trimmed);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter") {
            e.preventDefault();
            (e.target as HTMLInputElement).blur();
        } else if (e.key === "Escape") {
            e.preventDefault();
            setName(layerName);
            (e.target as HTMLInputElement).blur();
        }
    };

    return (
        <div style={{ height: SEQUENCE_TRACK_ROW_HEIGHT, display: "flex", alignItems: "center", padding: "0 10px" }}>
            <TextField
                value={name}
                onChange={(e) => setName(e.target.value)}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                variant="outlined"
                size="small"
                placeholder="Track name"
                sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                        height: 32,
                        backgroundColor: "#F9FAFB",
                        borderRadius: "6px",
                        boxSizing: "border-box",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#D1D5DB",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9CA3AF",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#3B82F6",
                    },
                }}
                inputProps={{
                    style: {
                        fontSize: "13px",
                        padding: "0 10px",
                    },
                }}
            />
        </div>
    );
});

export default SequenceTrackNameField;
